module.exports = __webpack_public_path__ + "static/media/007.8bd4703c.svg";